import { useEffect, useState } from 'react';
import { BusinessReportAddRow } from '../../../types/businessreport/BusinessReportAddRow';
import {
  EmptySuggestionForBusinessReport,
  SuggestionForBusinessReport,
} from '../../../types/search/SuggestionForBusinessReport';
import TimePicker from '../../../components/picker/TimePicker';
import { dateToTimeString, stringToTime } from '../../../utils/datepickerUtil';
import SubmitAndCancelButton from '../../../components/button/SubmitAndCancelButton';
import { FormCheck } from 'react-bootstrap';
import ProjectNumberSearch from '../../../components/search/ProjectNumberSearch';
import { formatProjectName } from '../../../utils/formatProjectName';

interface AddBusinessReportRowProps {
  item: BusinessReportAddRow;
  onChange: (
    itemId: string,
    key: keyof BusinessReportAddRow,
    value: string | boolean | number
  ) => void;
  onSubmit: (itemId: string) => void;
  onCancel: (itemId: string) => void;
}

const AddBusinessReportRow = ({
  item,
  onChange,
  onSubmit,
  onCancel,
}: AddBusinessReportRowProps) => {
  const [projectData, setProjectData] = useState<SuggestionForBusinessReport>(
    EmptySuggestionForBusinessReport
  );
  // 小数点以下も表示するため、string 型で管理
  const [manHourTotal, setManHourTotal] = useState<string>(
    item.manHoursTotal.toString()
  );

  // 始業時間と終業時間が変更されたら、工数合計を計算して設定
  useEffect(() => {
    if (item.startTime === null || item.endTime === null) {
      return;
    }
    const start = stringToTime(item.startTime);
    const end = stringToTime(item.endTime);

    if (start === null || end === null) {
      return;
    }

    const diff = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
    setManHourTotal(diff.toString());
    onChange(item.id, 'manHoursTotal', diff);
  }, [item.startTime, item.endTime]);

  return (
    <>
      <td>{item.date}</td>
      <td>
        <ProjectNumberSearch
          onSearch={(data) => {
            setProjectData(data);
            onChange(item.id, 'projectId', data.value);
            setProjectData(data);
          }}
        />
      </td>
      <td>{formatProjectName(projectData.label)}</td>
      {['A', 'B', 'C', 'D', 'E'].map((key) => (
        <td key={key}>
          <FormCheck
            key={key}
            type="radio"
            name={`manHoursCategory-${item.id}`}
            checked={item.manHoursCategory === key}
            onChange={() => onChange(item.id, 'manHoursCategory', key)}
          />
        </td>
      ))}
      <td>
        <TimePicker
          selectedTime={stringToTime(item.startTime)}
          setSelectedTime={(time) =>
            onChange(item.id, 'startTime', time ? dateToTimeString(time) : '')
          }
        />
      </td>
      <td>
        <TimePicker
          selectedTime={stringToTime(item.endTime)}
          setSelectedTime={(time) =>
            onChange(item.id, 'endTime', time ? dateToTimeString(time) : '')
          }
        />
      </td>
      <td>{manHourTotal}</td>
      <td>
        <SubmitAndCancelButton
          onSubmit={() => onSubmit(item.id)}
          onCancel={() => onCancel(item.id)}
        />
      </td>
    </>
  );
};

export default AddBusinessReportRow;
